export default "__VITE_ASSET__D1kNvRC0__"